<template>
  <div id="whats-on-component">
    <div id="whats-on-content">
      <h2>whats on</h2>
      <p id="notice">
        Notice: Small groups will be taking a break over August. We will resume
        our usual schedule in September. <br /><br />During August we will be
        running a summer series called "Holy-days" and enjoy being together as a
        church family. We'll be meeting for cafe style church and our time
        together will include sung worship, creative ways of praying, teaching
        from the Bible and of course cake!
      </p>
      <div id="carousel-track">
        <div class="event-card">
          <picture>
            <source srcset="@/assets/images/carousel/sun-1.webp" />
            <img
              src="@/assets/images/carousel/sun-1.png"
              alt=""
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div class="event-card-info-container">
            <div class="event-card-header">
              <h3>Holy-Days Service</h3>
              <h5>Sunday 3rd August 10.45am</h5>
            </div>
            <p>Introduction to our summer series and a focus on the bible</p>
          </div>
        </div>
        <div class="divider">
          <span>this week</span>
          <div class="divider-line"></div>
          <span>coming soon</span>
        </div>
        <div class="event-card">
          <picture>
            <source srcset="@/assets/images/carousel/sun-2.webp" />
            <img
              src="@/assets/images/carousel/sun-2.png"
              alt=""
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div class="event-card-info-container">
            <div class="event-card-header">
              <h3>Holy-Days Service</h3>
              <h5>Sunday 10th August 10.45am</h5>
            </div>
            <p>We continue our summer series and focus on communion</p>
          </div>
        </div>
        <div class="event-card">
          <picture>
            <source srcset="@/assets/images/carousel/sun-3.webp" />
            <img
              src="@/assets/images/carousel/sun-3.png"
              alt=""
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div class="event-card-info-container">
            <div class="event-card-header">
              <h3>Holy-Days Service</h3>
              <h5>Sunday 17th August 10.45am</h5>
            </div>
            <p>We continue our summer series and focus on prayer</p>
          </div>
        </div>
        <div class="event-card">
          <picture>
            <source srcset="@/assets/images/carousel/sun-4.webp" />
            <img
              src="@/assets/images/carousel/sun-4.png"
              alt=""
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div class="event-card-info-container">
            <div class="event-card-header">
              <h3>Holy-Days Service</h3>
              <h5>Sunday 24th August 10.45am</h5>
            </div>
            <p>We continue our summer series and focus on fellowship</p>
          </div>
        </div>
        <div class="event-card">
          <picture>
            <source srcset="@/assets/images/carousel/sun-1.webp" />
            <img
              src="@/assets/images/carousel/sun-1.png"
              alt=""
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div class="event-card-info-container">
            <div class="event-card-header">
              <h3>Holy-Days Service</h3>
              <h5>Sunday 31st August 10.45am</h5>
            </div>
            <p>
              The final installment in our summer series - We will focus on
              thanksgiving and praise
            </p>
          </div>
        </div>
      </div>
      <div id="helper-container">
        <button id="left-arrow">
          <img
            src="@/assets/utility/arrow.png"
            alt="left arrow"
            loading="lazy"
            decoding="async"
            draggable="false"
          />
        </button>
        <span>scroll</span>
        <button id="right-arrow">
          <img
            src="@/assets/utility/arrow.png"
            alt="right arrow"
            loading="lazy"
            decoding="async"
            draggable="false"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhatsOnComponent",
  data() {
    return {
      mouseDown: false,
      startX: null,
      scrollLeft: null,
      carouselTrack: null,
    };
  },
  mounted() {
    this.carouselTrack = document.querySelector("#carousel-track");

    this.carouselTrack.addEventListener("mousemove", this.move, false);
    this.carouselTrack.addEventListener("mousedown", this.startDragging, false);
    this.carouselTrack.addEventListener("mouseup", this.stopDragging, false);
    this.carouselTrack.addEventListener("mouseleave", this.stopDragging, false);

    document
      .querySelector("#left-arrow")
      .addEventListener("click", this.moveLeft, false);

    document
      .querySelector("#right-arrow")
      .addEventListener("click", this.moveRight, false);
  },
  beforeDestroyed() {
    this.carouselTrack.removeEventListener("mousemove", this.move, false);
    this.carouselTrack.removeEventListener(
      "mousedown",
      this.startDragging,
      false
    );
    this.carouselTrack.removeEventListener("mouseup", this.stopDragging, false);
    this.carouselTrack.removeEventListener(
      "mouseleave",
      this.stopDragging,
      false
    );

    document
      .querySelector("#left-arrow")
      .removeEventListener("click", this.moveLeft, false);

    document
      .querySelector("#right-arrow")
      .removeEventListener("click", this.moveRight, false);
  },
  methods: {
    startDragging(e) {
      this.mouseDown = true;
      this.startX = e.pageX - this.carouselTrack.offsetLeft;
      this.scrollLeft = this.carouselTrack.scrollLeft;
    },
    stopDragging() {
      this.mouseDown = false;
    },
    move(e) {
      e.preventDefault();

      if (!this.mouseDown) {
        return;
      }

      const x = e.pageX - this.carouselTrack.offsetLeft;
      const scroll = x - this.startX;
      this.carouselTrack.scrollLeft = this.scrollLeft - scroll;
    },
    moveLeft() {
      this.carouselTrack.style.scrollBehavior = "smooth";
      this.carouselTrack.scrollLeft = this.carouselTrack.scrollLeft - 307;
      this.carouselTrack.style.scrollBehavior = "unset";
    },
    moveRight() {
      this.carouselTrack.style.scrollBehavior = "smooth";
      this.carouselTrack.scrollLeft = this.carouselTrack.scrollLeft + 307;
      this.carouselTrack.style.scrollBehavior = "unset";
    },
  },
};
</script>

<style scoped>
#whats-on-component {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 4rem 0;
  background-color: var(--background-dark);
}

#whats-on-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 3rem;
  width: 100%;
}

h2,
h3,
h5,
p {
  color: var(--text-light);
}

#notice {
  padding: 0 8rem;
  text-align: center;
}

#carousel-track {
  position: relative;
  display: flex;
  height: 400px;
  column-gap: 2rem;
  width: 100%;
  padding: 0 4rem;
  overflow: scroll;
  cursor: grab;
}

#carousel-track {
  scrollbar-width: none;
} /* Firefox */
#carousel-track {
  -ms-overflow-style: none;
} /* IE and Edge */
#carousel-track::-webkit-scrollbar,
#carousel-track::-webkit-scrollbar-button {
  display: none;
} /* Chrome */

.event-card {
  position: relative;
  width: 275px;
  min-width: 275px;
  height: 400px;
  border-radius: 2rem;
  overflow: hidden;
  z-index: 0;
}

.event-card picture {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.event-card picture img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.event-card-info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2rem;
  width: 100%;
  height: 100%;
  padding: 50% 1.5rem 1.5rem;
  text-align: center;
  background-color: #00000088;
  user-select: none;
}

.event-card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.5rem;
}

.event-card-info-container h3 {
  height: fit-content;
  font-family: boldoa;
  font-size: 1.5rem;
  text-transform: uppercase;
  line-height: 1;
  text-align: center;
}

.event-card-info-container h5 {
  height: fit-content;
  font-family: bree-serif;
  font-size: 0.8rem;
  line-height: 1;
  text-align: center;
}

.event-card-info-container h5 s {
  color: var(--text-light);
  text-decoration-color: var(--highlight);
  text-decoration-thickness: 2px;
}

.event-card-info-container p {
  margin-bottom: 0.5rem;
}

.divider {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.divider span {
  height: fit-content;
  color: var(--text-light);
  font-family: boldoa;
  font-size: 2rem;
  text-transform: uppercase;
  line-height: 1.4;
  text-align: center;
  text-wrap: nowrap;
  user-select: none;
}

.divider span:first-child {
  writing-mode: vertical-lr;
}

.divider span:last-child {
  writing-mode: vertical-lr;
  rotate: 180deg;
}

.divider-line {
  height: 100%;
  width: 0.5rem;
  padding: 2rem 0;
  background-color: var(--highlight);
  border-radius: 10rem;
}

#helper-container {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

#helper-container button {
  background-color: unset;
  border: none;
  cursor: pointer;
}

#helper-container img {
  height: 1.5rem;
}

#right-arrow img:first-child {
  transform: scaleX(-1);
}

#helper-container span {
  color: var(--text-light);
  font-family: boldoa;
  font-size: 1rem;
  text-transform: uppercase;
  text-align: center;
}

@media screen and (max-width: 800px) {
  #notice {
    padding: 0 2rem;
  }
}
</style>
